import { gql } from "@apollo/client";

export const GET_CUSTOM_FIELD_DATA = gql`
  query getCustomFieldData($parentId: ID!, $parentType: ParentType!) {
    getCustomFieldData(parentId: $parentId, parentType: $parentType) {
      id
      fieldSettingId
      values
    }
  }
`;
